/* eslint-disable @typescript-eslint/no-explicit-any */
// /* eslint-disable @typescript-eslint/no-explicit-any */
// export const getImageUrl = async (res:any) =>{
//     // console.log("hello123",res)
//     // const imageBlob = new Blob([res], {
//     //     type: "application/jpg"
//     // });;
//     // const imageObjectURL = URL.createObjectURL(res);

//     return 0
// }

export const errorHandling = (error: any, setErrorMessage: any) => {
  if (error.response?.status === 400 || error.response?.status === 404) {
    setErrorMessage(error.response.data.detail);
  }
  if (error.response.status === 422) {
    const errorBody: any = {};
    error.response.data.detail.forEach((item: any) => {
      let cleanedMessage = item['msg'].replace(/[^a-zA-Z0-9\s]/g, ' ');
      cleanedMessage =
        cleanedMessage.charAt(0).toUpperCase() + cleanedMessage.slice(1);
      errorBody[item['loc'].pop()] = cleanedMessage;
    });
    setErrorMessage(errorBody);
  }
};

export function getYearMonthDiff(date1: Date, date2: Date) {
  const diffMs = date2.getTime() - date1.getTime();

  // Convert milliseconds to years and months
  const msPerMonth = 1000 * 60 * 60 * 24 * 30.44; // average month length
  const months = Math.floor(diffMs / msPerMonth) + 1;
  console.log(months);
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;
  const yearsString = years > 1 ? 'years' : 'year';
  const monthsString = months > 1 ? 'months' : 'month';

  const result =
    years > 0
      ? `${years} ${yearsString} ${remainingMonths} ${monthsString}`
      : `${remainingMonths} ${monthsString}`;

  return result;
}

export const reorder = (list: any, startIndex: any, endIndex: any) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
